import { useDispatch } from "react-redux";
import { showErrorToastMessage, showSuccessToastMessage } from "../../../../../component/Toasts/Toasts";
import * as actions from "../../../../../Redux/Actions/index";
import { Strings } from "../../../../../constant/Strings";

const DeleteExperiences = (props: any) => {
  const { deleteSuccess, confirmDelete, cancel, submit} = Strings;
  const { id, hideDeleteExperiences ,getApiDispatch} = props;
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(
      actions.deleteExperienceDataAction(id, (res: any) => {
        if (res) {
          if (res.error) {
            if (res.error.error_description) {
              showErrorToastMessage(res.error.error_description);
              hideDeleteExperiences();
            }
          } else {
            if (res.code === 200) {
              hideDeleteExperiences();
              getApiDispatch();
              showSuccessToastMessage(deleteSuccess);
            }
          }
        }
      })
    );
  };

  return (
    <div className="container">
      <div className="row mx-auto">{confirmDelete}</div>
      <div className="modal-btn-wrapper mt-5 mx-auto">
        <div>
          <button
            className="btn cancel-btn buttonsize"
            onClick={hideDeleteExperiences}
          >
            {cancel}
          </button>
        </div>
        <div>
          <button
            className="btn add-submit-button buttonsize"
            onClick={handleDelete}
          >
            {submit}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteExperiences;
